import { createModel, createSaga, createReducer } from '@/store/tools';
import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';


const model = {
    namespace: 'financialset',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getFinancial': T('getFinancial'),
        },
        actions: {
            'getFinancial': A('getFinancial'), // 获取财务数据
        },
        sagas: {
            'getFinancial': S('getFinancial', '/?cmd=com.xqxc.api.pig.mis.biz.platform.SettlementParamService.settlementParamQuery', 'POST'),
        },
        reducers: {
            'financial': R('getFinancial', {}),
        }
    })
};
export default createModel(model);